import { BufferService } from "./buffer.service"

export class ShipmentService extends BufferService {
    constructor() {
        super('Shipment', 'main')
    }
}
